import { InputAdornment } from '@mui/material';
import merge from 'lodash/merge';
import React, { useCallback, useMemo, useState, forwardRef } from 'react';

import IconButton from '@/@mantis/components/@extended/IconButton';
import { EyeIcon } from '@/assets/icons/EyeIcon';
import { EyeOffIcon } from '@/assets/icons/EyeOffIcon';

import FormTextField, { Props as FormTextFieldProps } from './FormTextField';

type Props = Omit<FormTextFieldProps, 'rows' | 'multiline' | 'type'>;

const FormPassword = forwardRef<HTMLInputElement, Props>(
  ({ color = 'secondary', ...props }, ref) => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const Adornment = useCallback(
      () => (
        <InputAdornment position="end" sx={{ mr: -1 }}>
          <IconButton onClick={() => setIsPasswordVisible(flag => !flag)} color={color}>
            {isPasswordVisible ? <EyeOffIcon /> : <EyeIcon />}
          </IconButton>
        </InputAdornment>
      ),
      [isPasswordVisible, color]
    );

    const mergedProps = useMemo(
      () =>
        merge(props, {
          color,
          textFieldProps: {
            type: isPasswordVisible ? 'text' : 'password',
            slotProps: {
              input: {
                endAdornment: <Adornment />,
              },
            },
          },
        }),
      [props, color, isPasswordVisible, Adornment]
    );

    return <FormTextField {...mergedProps} ref={ref} />;
  }
);

export default FormPassword;
